import type {
  MRT_ColumnFiltersState,
  MRT_SortingState
} from "mantine-react-table-open";

export interface StoredSessionState {
  pageIndex: number;
  columnFilters: MRT_ColumnFiltersState;
  globalFilter: string;
  sorting: MRT_SortingState;
}

/** Validates each piece of the stored state on its own, using the default for any that is missing or malformed. */
export function parseStoredSessionState(
  value: unknown,
  defaults: StoredSessionState
): StoredSessionState {
  if (!isRecord(value)) {
    return defaults;
  }

  return {
    pageIndex:
      typeof value.pageIndex === "number" &&
      Number.isInteger(value.pageIndex) &&
      value.pageIndex >= 0
        ? value.pageIndex
        : defaults.pageIndex,
    columnFilters: isColumnFilters(value.columnFilters)
      ? value.columnFilters
      : defaults.columnFilters,
    globalFilter:
      typeof value.globalFilter === "string"
        ? value.globalFilter
        : defaults.globalFilter,
    sorting: isSorting(value.sorting) ? value.sorting : defaults.sorting
  };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function isColumnFilters(value: unknown): value is MRT_ColumnFiltersState {
  return (
    Array.isArray(value) &&
    value.every((filter) => isRecord(filter) && typeof filter.id === "string")
  );
}

function isSorting(value: unknown): value is MRT_SortingState {
  return (
    Array.isArray(value) &&
    value.every(
      (sort) =>
        isRecord(sort) &&
        typeof sort.id === "string" &&
        typeof sort.desc === "boolean"
    )
  );
}
